/**
 * @deprecated Prefer var(--text-variants-header-l), var(--text-variants-header-m), etc. instead of TextVariants constant
 */
export const TextVariants = {
  header: {
    l: {
      fontSize: '32px',
      fontWeight: '700',
    },
    m: {
      fontSize: '24px',
      fontWeight: '500',
    },
    s: {
      fontSize: '20px',
      fontWeight: '500',
    },
  },
  title: {
    l: {
      fontSize: '16px',
      fontWeight: '500',
    },
    m: {
      fontSize: '14px',
      fontWeight: '500',
    },
    sMedium: {
      fontSize: '12px',
      fontWeight: '500',
    },
  },
  body: {
    l: {
      fontSize: '16px',
      fontWeight: '400',
    },
    m: {
      fontSize: '14px',
      fontWeight: '400',
    },
    s: {
      fontSize: '12px',
      fontWeight: '400',
    },
    sMedium: {
      fontSize: '12px',
      fontWeight: '500',
    },
    xs: {
      fontSize: '10px',
      fontWeight: '400',
    },
  },
  button: {
    m: {
      fontSize: '16px',
      fontWeight: '500',
    },
    s: {
      fontSize: '12px',
      fontWeight: '500',
    },
  },
  textfield: {
    m: {
      fontSize: '16px',
      fontWeight: '400',
    },
    s: {
      fontSize: '14px',
      fontWeight: '400',
    },
  },
} as const;
